import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { BankGuarantee, BankGuaranteeCreateDTO } from '../interfaces/bank/cheque.interface';

export const BankGuaranteeService = {
  list: async (institutionId: string, status?: string, expiringWithinDays?: number): Promise<BankGuarantee[]> => {
    const params: Record<string, string | number> = {};
    if (status) params.status = status;
    if (expiringWithinDays !== undefined) params.expiringWithinDays = expiringWithinDays;
    return (await axios.get(ENDPOINTS.BANK_GUARANTEE.LIST(institutionId), { params })).data;
  },
  get: async (id: string): Promise<BankGuarantee> => (await axios.get(ENDPOINTS.BANK_GUARANTEE.ONE(id))).data,
  create: async (dto: BankGuaranteeCreateDTO): Promise<BankGuarantee> =>
    (await axios.post(ENDPOINTS.BANK_GUARANTEE.BASE, dto)).data,
  amend: async (id: string, dto: { amount: number; expiryDate: string; claimExpiryDate?: string; notes?: string }):
    Promise<BankGuarantee> => (await axios.put(ENDPOINTS.BANK_GUARANTEE.AMEND(id), dto)).data,
  commission: async (id: string, dto: { amount: number; commissionDate?: string; commissionAccountId?: string; notes?: string }):
    Promise<BankGuarantee> => (await axios.post(ENDPOINTS.BANK_GUARANTEE.COMMISSION(id), dto)).data,
  release: async (id: string, actionDate?: string, notes?: string): Promise<BankGuarantee> =>
    (await axios.post(ENDPOINTS.BANK_GUARANTEE.RELEASE(id), { actionDate, notes })).data,
  invoke: async (id: string, actionDate?: string, notes?: string): Promise<BankGuarantee> =>
    (await axios.post(ENDPOINTS.BANK_GUARANTEE.INVOKE(id), { actionDate, notes })).data,
  expireLapsed: async (institutionId: string): Promise<{ expired: number }> =>
    (await axios.post(ENDPOINTS.BANK_GUARANTEE.EXPIRE_LAPSED(institutionId))).data,
};
